var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuex-table',{staticClass:"users-table",attrs:{"fields":_vm.fields,"filter_items":_vm.filtered_fields,"table_store":"amo_widget/users/table"},scopedSlots:_vm._u([{key:"type",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$t(("voice.trunk.type." + (item.type))))+" ")]}},{key:"sip_account",fn:function(ref){
var item = ref.item;
return [_c('sip-account',{attrs:{"login":item.sip_login,"password":item.sip_password}})]}},{key:"client",fn:function(ref){
var detailsShowing = ref.detailsShowing;
var toggleDetails = ref.toggleDetails;
var item = ref.item;
return [_c('div',{staticClass:"mainip_more"},[_c('span',[_vm._v(_vm._s(item.client))]),_c('table-button-more',{attrs:{"is_show":detailsShowing,"is_text":false},on:{"click":toggleDetails}})],1)]}},{key:"row-details",fn:function(ref){
var item = ref.item;
return [_c('table-ips',{attrs:{"id":item.id,"server":item.server}})]}},{key:"actions",fn:function(ref){
var item = ref.item;
return [_c('table-dropdown',[_c('span',{staticClass:"dropdown-item-icon dropdown-item-icon--edit",on:{"click":function($event){return _vm.edit_item(item)}}},[_vm._v(" "+_vm._s(_vm.$t('shared.component.table.action.edit'))+" ")])])]}},{key:"state",fn:function(ref){
var value = ref.formatted;
return [_c('status-badge',{attrs:{"value":value}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }